<div class="flex-1 bg-[url(/assets/open-books-background.png)] bg-cover bg-center bg-no-repeat lg:min-h-[37.5rem]">
  <div
    class="h-full flex flex-col py-5 px-10 items-center gap-10 md:p-10
           lg:items-start lg:justify-center lg:gap-[clamp(2rem,5vw,8.75rem)] lg:flex-row lg:py-20 lg:px-[clamp(3rem,7vw,8.75rem)]">
    <!-- Login / Forgot Password form card -->
    <div class="w-full shrink-0 order-2 md:w-[25rem] lg:order-1">
      @if (isForgotPassword) {
        <px-forgot-password (goBackToLogin)="goBackToLogin()"/>
      } @else {
        <mat-card>
          <mat-card-content class="p-5">
            <span class="text-headline-large">Login</span>
            <px-login (forgotPasswordRequest)="forgotPasswordRequest()"/>
          </mat-card-content>
        </mat-card>
      }
    </div>

    <!-- Information section -->
    <div class="flex flex-col order-1 w-full px-2 md:px-0 md:w-[29rem] lg:w-auto lg:order-2 lg:place-content-around lg:h-fit lg:grow lg:py-6 gap-4">
      @if (isForgotPassword) {
        <span class="text-display-small">Forgot your password?</span>
        <span class="text-body-large lg:text-headline-small">Enter your email address to receive directions on how to reset your password.</span>
      } @else {
        <span class="text-display-small lg:text-display-medium">Welcome!</span>
        <span class="text-body-large lg:text-headline-small">
          Please login to access your account, place holds and discover everything {{ organizationSelectors.name | select }} has to offer!
        </span>
      }
      <span class="text-title-large">
        New to our library?
        <mx-link-button label="Create an account" linkType="inline" (click)="onClickCreateAccount()"/>
        today!
      </span>
    </div>
  </div>
</div>
